






























import {Vue, Component, Prop} from 'vue-property-decorator'

import BaseModal from '../common/BaseModal.vue'

@Component({
  components: {
    BaseModal,
  }
})
export default class BankConfirmModal extends Vue {
  @Prop({default: ''}) bankUserName: string
  @Prop({default: ''}) bankName: string
  @Prop({default: ''}) bankAccount: string
}
